import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

function ClientAssignmentWarningModal({ showModal, hideModal, loading, confirmUpdate }) {
    const confirmUpdateHandler = () => {
        confirmUpdate();
        hideModal();
    }
    
    return (
        <Modal
            show={showModal}
            onHide={hideModal}
            centered
        >
            <Modal.Header className="modal__header">
                <span>Confirm Changes to Client Assignment Permission</span>
                <span
                    className="modal__header__btn"
                    onClick={hideModal}
                    aria-label='Exit'
                >
                    X
                </span>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex justify-content-center">
                    {loading ?
                        <Spinner animation='border' style={{ textAlign: "center" }} />
                        :
                        <p style={{ textAlign: "center" }}>
                            Are you sure that you want to switch the staff's assignment permission to assign clients via program enrollment? Doing so will unassign existing clients from this staff.
                        </p>
                    }
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-primary" onClick={hideModal}>Cancel</Button>
                <Button variant="primary" onClick={confirmUpdateHandler}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ClientAssignmentWarningModal
